/**
 * @generated SignedSource<<8c0a586cb4532e161c93223bb1c69471>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoResponseNumberScreenQuery$variables = {
  todoId: string;
};
export type TodoResponseNumberScreenQuery$data = {
  readonly todo: {
    readonly id: string;
    readonly response: {
      readonly value?: number | null;
    } | null;
    readonly responseDescription: string | null;
  } | null;
};
export type TodoResponseNumberScreenQuery = {
  response: TodoResponseNumberScreenQuery$data;
  variables: TodoResponseNumberScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "todoId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "todoId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseDescription",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "type": "TodoResponseNumber",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoResponseNumberScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "response",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoResponseNumberScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "response",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e1f3ab9850ec5d45404050026dca1d43",
    "id": null,
    "metadata": {},
    "name": "TodoResponseNumberScreenQuery",
    "operationKind": "query",
    "text": "query TodoResponseNumberScreenQuery(\n  $todoId: ID!\n) {\n  todo(id: $todoId) {\n    id\n    responseDescription\n    response {\n      __typename\n      ... on TodoResponseNumber {\n        value\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc2815d0a4ada9356ec5dc75dd75da0d";

export default node;
